import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer style={{ background: '#0a0d0a' }} className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-leaf-line text-green-400 text-xl"></i>
            </div>
            <span className="text-white font-bold">CornVest</span>
            <span className="text-white/30 text-sm">{t('footer.tagline')}</span>
          </div>
          <div className="flex flex-wrap gap-5 items-center">
            <a href="#why-grows" className="text-white/40 hover:text-white/70 text-xs transition-colors">{t('footer.about')}</a>
            <a href="#packages" className="text-white/40 hover:text-white/70 text-xs transition-colors">{t('footer.packages')}</a>
            <a href="#calculator" className="text-white/40 hover:text-white/70 text-xs transition-colors">{t('footer.calculator')}</a>
          </div>
          <div className="text-white/25 text-xs">{t('footer.disclaimer')}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
